<template>
    <div class="no-displayed-recommendation">
        <div class="no-displayed-recommendation__art" aria-hidden="true">
            <MaltImg :src="getBrandIllustration('malt-brand-search.svg')" alt="No review illustration" height="160" />
        </div>
        <VJoyText preset="primary-450" class="no-displayed-recommendation__title">
            {{ t('profile.section.appraisals.no.reviews.to.display.label') }}
        </VJoyText>
        <VJoyText preset="primary-300" class="no-displayed-recommendation__text">
            {{ t('profile.section.appraisals.no.reviews.freelancer.private.choice', {0: freelancerName}) }}
        </VJoyText>
    </div>
</template>

<script setup lang="ts">
    import {MaltImg} from '#components';
    import {useTranslation} from '#imports';
    import {getBrandIllustration} from '@malt/asset-utils';
    import {VJoyText} from '@maltjoy/core-vue';

    defineProps<{freelancerName?: string}>();

    const {t} = useTranslation();
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint' as joy;

    .no-displayed-recommendation {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        color: var(--joy-color-neutral-30);
        gap: var(--joy-core-spacing-2);
        padding: var(--joy-core-spacing-6) var(--joy-core-spacing-4);

        &__art {
            width: 220px;
            height: 160px;
            display: grid;
            place-items: center;
        }
    }
</style>
